const EMPTY_PRERENDER_DATA = Object.freeze({
  generatedAt: null,
  warps: {
    list: [],
    byId: {},
  },
  realEstate: {
    list: [],
    byId: {},
  },
  blog: {
    list: [],
    bySlug: {},
  },
  submissions: {
    list: [],
  },
});

export const DIRECTORY_PAGE_LIMIT = 1000;

export function isReactSnapCrawler() {
  return (
    typeof navigator !== "undefined" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent === "ReactSnap"
  );
}

export function getPrerenderData() {
  if (typeof window === "undefined") {
    return EMPTY_PRERENDER_DATA;
  }

  return window.__MCVERSE_PRERENDER_DATA__ || EMPTY_PRERENDER_DATA;
}

export function getPrerenderWarpList() {
  return getPrerenderData().warps?.list || [];
}

export function getPrerenderWarp(id) {
  return getPrerenderData().warps?.byId?.[String(id)] || null;
}

export function getPrerenderListingList() {
  return getPrerenderData().realEstate?.list || [];
}

export function getPrerenderListing(id) {
  return getPrerenderData().realEstate?.byId?.[String(id)] || null;
}

export function getPrerenderBlogPostList() {
  return getPrerenderData().blog?.list || [];
}

export function getPrerenderBlogPost(slug) {
  return getPrerenderData().blog?.bySlug?.[String(slug)] || null;
}

export function getPrerenderSubmissionList() {
  return getPrerenderData().submissions?.list || [];
}
